import api from './client';

export interface Notification {
  id: string;
  user_id: string;
  type: string;
  title: string;
  message: string;
  resource_type?: string;
  resource_id?: string;
  is_read: boolean;
  data?: Record<string, unknown>;
  created_at: string;
  read_at?: string;
}

export async function listNotifications(params?: { unread_only?: boolean; limit?: number; offset?: number }) {
  const res = await api.get<Notification[]>('/notifications', { params });
  return res.data;
}

export async function getUnreadCount() {
  const res = await api.get<{ unread_count: number }>('/notifications/unread-count');
  return res.data.unread_count;
}

export async function markAsRead(notificationId: string) {
  const res = await api.patch<Notification>(`/notifications/${notificationId}`, { is_read: true });
  return res.data;
}

export async function markAllRead() {
  await api.post('/notifications/mark-all-read');
}
